import Select from "react-select";

import { selectStyles } from "./selectStyleOptions";

import innerStyles from "./searchBlockRHF.module.css";

export default function SearchBlockRHF({
  options,
  handleSearch,
  handleClear,
  handleChange,
  externalStyles,
  searchParams,
}) {
  return (
    <>
      <h2 className={innerStyles["container-caption"]}>{options.caption}</h2>
      <div className={innerStyles["search-container"]}>
        <div className={externalStyles?.[`grid-container${options?.gridKey ? options.gridKey : ""}`]}>
          {Object.values(options.inputsOptions)?.map((item) => {
            switch (item.type) {
              case "selectWithSearch": {
                return (
                  <div
                    key={item.key}
                    className={externalStyles?.[`box-${item.key}`]}>
                    <div className={innerStyles["input-container"]}>
                      <label>{item.label}</label>
                      <Select
                        noOptionsMessage={() => "Нет данных"}
                        classNamePrefix="react-select"
                        data-id={item.key}
                        isSearchable={item.isSearchable}
                        value={item?.options?.find((elem) => elem.value === searchParams?.[item.key]) || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder={item.placeholder || "Выберите"}
                        options={item.options}
                        styles={selectStyles}
                      />
                    </div>
                  </div>
                );
              }
              default:
                return (
                  <div
                    key={item.key}
                    className={externalStyles?.[`box-${item.key}`]}>
                    <div className={innerStyles["input-container"]}>
                      <label>{item.label}</label>
                      <input
                        data-id={item.key}
                        type={item.type}
                        className={innerStyles["form-input"]}
                        placeholder={item.placeholder}
                        value={searchParams?.[item.key]}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                );
            }
          })}
        </div>
        <div className={innerStyles["buttons-block"]}>
          <button
            id="search"
            className={innerStyles["search-btn"]}
            onClick={(e) => handleSearch(e)}>
            <span className={innerStyles["search-icon"]}></span>
            <span>Найти</span>
          </button>
          <button
            id="clear"
            className={innerStyles["clear-btn"]}
            onClick={handleClear}>
            Очистить
          </button>
        </div>
      </div>
    </>
  );
}
